<template>
  <div class="animated fadeIn">
    <b-card>
      <template slot="header">
        <i class='fa fa-align-justify'></i> Pattern List
      </template>

      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label>Registed_at</label>
              <b-form inline>
                <date-picker class="mt-2 mr-2" v-model="so.opt.created_at_sd" style="width: 140px" :confirm="false" :first-day-of-week="1" @keyup.enter="refresh"></date-picker>
                ~
                <date-picker class="ml-2" v-model="so.opt.created_at_ed" style="width: 140px" :confirm="false" :first-day-of-week="1" @keyup.enter="refresh"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="primary" @click="refresh"> Search </b-button>
          <b-button class= "mr-1" size="sm" variant="light" @click="resetField"> Reset </b-button>
          <b-button class= "mr-1" size="sm" variant="danger" @click="so.adv = false"> Close </b-button>
        </b-form-group>
      </b-card>

      <b-row>
        <b-col>
          <b-form-fieldset style="width : 120px" class="d-inline" size="sm">
            <b-form-select :options="so.pageoptions" v-model="so.perPage">
            </b-form-select>
          </b-form-fieldset>
          <b-button class="d=inline ml-2" size="sm" variant="success" @click="() => selectAllRows()">
            <span v-if="selected.length">
              unselect
            </span>
            <span>
              select
            </span>
            all
          </b-button>
          <b-button class="d=inline ml-2" size="sm" variant="warning" @click="() => publish()">
            Change to Publish
          </b-button>
          <b-button class="d=inline ml-2" size="sm" variant="primary" @click="() => unpublish()" v-if="is_publish">
            Change to Unpublish
          </b-button>
          <label for="filter_publish" v-if="is_publish">
            <c-switch color="info" label size="lg" id="filter_publish" class="pt-2 ml-3" v-model="is_publish_filter" @change="() => refresh()" />
            <span class="ml-2">Filter Published</span>
          </label>
        </b-col>
        <b-col>
          <b-input-group style="width : 90%" size="sm" class= "float-right">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='code';so.skt='Indicator'">Indicator</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='code_hash';so.skt='Indicator Hash'">Indicator Hash</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='type';so.skt='Type'">Type</b-dropdown-item>
              </b-dropdown>
            </b-input-group-prepend>

            <b-dropdown v-if="so.sk == 'type'" :text="so.sv || ''" size="sm" variant="outline-secondary" class="scroll-dropdown">
              <b-dropdown-item v-for="(x, index) in codes.policy" :key="index" size="sm" @click="() => so.sv = x">
                {{ x }}
              </b-dropdown-item>
            </b-dropdown>
            <b-input v-else v-model="so.sv" @keyup.enter="refresh()"></b-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="so.adv = !so.adv"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>

      <b-table
        hover
        striped
        small
        responsive="sm"
        ref="_list"
        show-empty
        empty-text="not found"
        select-mode="multi"
        selectable
        @row-selected="onRowSelected"
        select
        :items="getItems"
        :fields="fields"
        :current-page="so.currentPage"
        :per-page="so.perPage"
        :sortBy="so.sk">

        <template #cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>


        <template #cell(id)="row">{{row.item.id}}</template>

        <template #cell(is_alive)="row">
          <b-badge variant="success" v-if="row.item.is_alive">Enable</b-badge>
          <b-badge v-else variant="secondary">Disable</b-badge>
        </template>
        <template #cell(is_excute)="row">
          <b-badge variant="danger" v-if="row.item.is_excute">Yes</b-badge>
          <b-badge v-else variant="secondary">-</b-badge>
        </template>
        <template #cell(is_binary)="row">
          <b-badge variant="warning" v-if="row.item.is_binary">Yes</b-badge>
          <b-badge v-else variant="secondary">-</b-badge>
        </template>
        <template #cell(code)="row">
          <i class="fa fa-search d-inline text-primary"></i>
          <Data class="d-inline ml-2" :data="row.item.code" :tooltip="row.item.code_hash" :isFunction="true" @click="detail(row.item)" :dataLength="10" />
        </template>
        <template #cell(code_country)="row">
          <span v-if="row.item.code_country" class="mr-1">
            {{ row.item.code_country }}
          </span>
          <span v-if="row.item.code_country" class="flag-icon" :class="`flag-icon-${row.item.code_country.toLowerCase()}`">
          </span>
          <span v-else>
            -
          </span>
        </template>

        <template #cell(created_at)="row">{{row.item.created_at | date }}</template>
        <template #cell(expire_at)="row">
          <span class="font-weight-bold" :class="{ 'text-danger' : checkExpire(row.item.expire_at) }">
            {{ row.item.expire_at | datetime2 }}
          </span>
        </template>
        <template #cell(origin)="row">
          <span class="">
            {{ row.item.origin }}
            <span v-if="row.item.broker">
              ({{ row.item.broker }})
            </span>
          </span>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col>
        </b-col>
        <b-col class="mt-1 d-flex justify-content-center">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"/>
        </b-col>
        <b-col v-if="profile.permission == 'Master'">
          <div class="pull-right">

          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import { Switch as cSwitch } from '@coreui/vue';
import vSelect from 'vue-select';
// import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import datepicker from '@/f1/custom';
import codes from '@/f1/codes';
import { api, auth } from '@/f1/service';
import 'vue2-datepicker/index.css';
import moment from 'moment-timezone';
import _ from 'lodash';
import Data from '@/f1/views/components/data';

const default_opt = () => ({
  perPage: 25,
  currentPage: 1, totalRows: 0,
  sk: 'code', sv: '', skt: 'indicator', opt : {
    created_at_sd: moment().add(-1, 'month').toDate(),
    created_at_ed: moment().add(1, 'd').toDate()
  }, adv: false,
  pageoptions : [
    {text:'10 rows',value:10},
    {text:'25 rows',value:25},
    {text:'50 rows',value:50},
    {text:'100 rows',value:100},
    {text:'200 rows',value:200}
  ]
});

export default {
  props: ['is_publish'],
  components: { DatePicker, vSelect, cSwitch, Data },
  data: () => ({
    is_publish_filter: false,
    selected: [],  // 선택된 항목을 저장할 배열
    rows: [],       // 모든 항목을 저장할 배열 (전체 선택 기능을 위해 필요)
    codes,
    datepicker,
    so : default_opt(),
    profile : auth.profile
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return [
        { key: 'id', thStyle: 'width: 5%', sortable: true, label: 'No' },
        { key: 'is_alive', sortable: true, label: 'Enable' },
        // { key: 'level', sortable: true, label: 'Level' },
        { key: 'type', sortable: true, label: 'Type' },
        { key: 'code', sortable: true, label: 'Indicator' },
        { key: 'hit', sortable: true, label: 'Frequency' },
        { key: 'created_at', sortable: true, label: 'Registed_at' },
        { key: 'expire_at', sortable: true, label: 'Expire_at' },
        { key: 'origin', sortable: true, label: 'Origin' },
    ]}
  },
  methods: {
    checkExpire(dateString, timezone = 'UTC') {
      // 입력된 날짜를 주어진 타임존으로 변환
      const inputDate = moment.tz(dateString, timezone).startOf('day');

      // 오늘 날짜를 주어진 타임존으로 가져오고 시간 부분을 0으로 설정
      const today = moment.tz(timezone).startOf('day');

      // 입력된 날짜가 오늘보다 이전인지 확인
      return inputDate.isBefore(today);
    },

    onRowSelected(items) {
      this.selected = items
    },
    selectAllRows() {
      if(this.selected.length) {
        this.$refs._list.clearSelected()
      } else {
        this.$refs._list.selectAllRows()
      }
    },

    resetField(){ this.so = default_opt(); this.refresh(); this.so.adv = !this.so.adv},
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    async load(ctx = {}) {
      let so = {
        ok : ctx.sortBy,
        od : ctx.sortDesc ? 'd' : 'a',
        pg : ctx.currentPage || this.so.currentPage || 1,
        pc : ctx.perPage || this.so.perPage || 10,
        sk : this.so.sk || 'frequency',
        sv : this.so.sv,
        opt: this.so.adv ? Object.assign({}, this.so.opt) : {}
      }
      // Build all
      var search = { limit: so.pc, offset: (so.pg - 1) * so.pc, and: [], or: [], sort: [] }
      // order
      if(so.ok) { search.sort.push({name: so.ok, op: so.od == 'd' && 'desc' }); }
      if(this.is_publish === false) { search.and.push({name: 'is_publish', op: '=', value: false }); }
      else {
        if(this.is_publish_filter === true) { search.and.push({name: 'is_publish', op: '=', value: false }); }
      }

      // else {
      //   search.and.push({name: 'is_publish', op: '=', value: true });
      // }

      // search
      if(so.sk && so.sv) {
        if(!so.ok){
          search.sort.push({name: so.sk, op: so.od == 'd' && 'desc' });
        }
        if(so.sk == "type") {
          search.or.push({name: so.sk, value: so.sv, op:'='});
        } else {
          search.or.push({name: so.sk, value: `%${so.sv}%`, op:'like'});
        }

      }
      // search (adv)
      for (let [key, value] of Object.entries(so.opt)) {
        if(value != null && value != ""){
          switch(key) {
            case 'created_at_sd' : search.and.push({name: 'created_at', value: new Date(value), op: '>=' }); break;
            case 'created_at_ed' : var d = new Date(value); d.setDate(d.getDate() + 1); search.and.push({name: 'created_at', value: d, op: '<' }); break;
            default: search.and.push({name: key, value: `%${value}%`, op: 'like' }); break;
          }
        }
      }

      try { let rs = await api.uwss.pattern.list(search); this.so.totalRows = rs.count; this.rows = rs.result; return this.rows; }
      catch(e) { this.$toastr.e(e.data || e); }
    },
    detail(item) { this.$router.push({ name: 'uwss_pattern', params: { id: item.id } }); },
    async publish() {
      try { let rs = await api.uwss.pattern.bulkPublish(_.map(this.selected, x => x.id)); console.log(rs); this.$toastr.i("successful updated"); this.refresh(); }
      catch(e) { this.$toastr.e(e.data || e); }
    },
    async unpublish() {
      try { let rs = await api.uwss.pattern.bulkUnpublish(_.map(this.selected, x => x.id)); console.log(rs); this.$toastr.i("successful updated"); this.refresh(); }
      catch(e) { this.$toastr.e(e.data || e); }
    },
  },
  created() { },
  destroyed() { },
  mounted() {  },
}
</script>
